/**
 * API Configuration
 * Dinámico por entorno: usa VITE_API_URL en producción, localhost en desarrollo
 */

// Detectar entorno y usar API URL correcta
// Prioridad: REACT_APP_ (CRA) > VITE_ (Vite) > Auto-detect Vercel > Localhost

// Fallback inteligente: si estamos en Vercel, usar API de Render
// Detect environment
const isLocal = typeof window !== 'undefined' &&
  (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1');

// Fallback logic for production domains
const defaultUrl = isLocal
  ? 'http://localhost:8000/api'
  : 'https://ztac-tacos-api.onrender.com/api';

const API_BASE = process.env.REACT_APP_API_URL ||
  (typeof import.meta !== 'undefined' && import.meta.env && import.meta.env.VITE_API_URL) ||
  defaultUrl;

console.log('🔧 [v2.1] API Base URL:', API_BASE);
console.log('🔍 Env Debug:', {
  REACT_APP: process.env.REACT_APP_API_URL ? 'Set' : 'Unset',
  VITE: (typeof import.meta !== 'undefined' && import.meta.env && import.meta.env.VITE_API_URL) ? 'Set' : 'Unset',
  isProduction: !isLocal,
  timestamp: new Date().toISOString()
});

// Export both default and named exports for compatibility
export default API_BASE;
export const API_URL = API_BASE;

// Local Printer Bridge URL (Silent printing on Windows)
// Prioridad: Localhost > IP del PC fija > Fallback
export const PRINTER_SERVICE_URL = 'http://localhost:8001';

// Config para requests con credentials
export const apiConfig = {
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json',
  }
};
